"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function TwoColumnLayoutCopy2() {
  const {
    ref: leftRef,
    isVisible: leftVisible
  } = useRevealOnScroll({
    threshold: 0.2,
    once: true
  });
  const {
    ref: rightRef,
    isVisible: rightVisible
  } = useRevealOnScroll({
    threshold: 0.2,
    once: true
  });
  return <section id="twocolumnlayout" className="w-full bg-background py-16 px-4 ![margin:-900px_0px_0px_0px] !h-[520px] md:hidden md:py-24">
      <div className="container mx-auto max-w-7xl">
        <div className="grid grid-cols-1 gap-12 items-center md:grid-cols-2 md:gap-16 lg:gap-20">
          {}
          <div ref={leftRef} className={`relative w-full md:hidden transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] ${leftVisible ? "opacity-100 translate-x-0" : "opacity-0 -translate-x-8"}`}>
            <div className="relative rounded-lg shadow-medium">
              
            </div>
          </div>

          {}
          <div ref={rightRef} className={`flex flex-col gap-6 md:hidden transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] ${rightVisible ? "opacity-100 translate-x-0" : "opacity-0 translate-x-8"}`}>
            
            <div className="flex flex-col gap-4">
              
              
              
            </div>
          </div>
        </div>
      </div>
    </section>;
}